import React, { useState } from 'react'
import classNames from 'classnames'

import ShortcutHelpers from 'helpers/ShortcutHelpers'
import { BurgerMenuIcon } from 'components/Utils/Icons'
import { OnboardingStepPopover } from 'screens/OnboardingPopover/'
import { SidebarHeaderLoading } from 'components/Layout/AppLoading'

export default ({ onClick, highlighted, showPlaceholder }) => {
  const [hover, setHover] = useState(false)
  if (showPlaceholder) {
    return <SidebarHeaderLoading />
  }
  return (
    <OnboardingStepPopover step="channels" position="bottom" align="start">
      <div className="inline-block">
        <div className="flexbox flexbox-align-center align-items padding-top-smaller margin-bottom-small margin-left-medium margin-top-medium">
          <div
            onClick={onClick}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            className={classNames(
              'flexbox-rows flexbox-align-center',
              'pointer flexbox padding-vertical-smaller padding-horizontal-small',
              'radius-normal transition',
              'background-shade-50-on-hover background-shade-45-on-active shade-10',
              { 'shade-20': !hover, primary: highlighted }
            )}
          >
            <div
              style={{ height: 24 }}
              className={classNames(
                'padding-top-smaller flexbox-align-center radius-normal'
              )}
            >
              <BurgerMenuIcon size={16} />
            </div>
            <div className="margin-left-small font-weight-medium font-size-large">
              {'All channels'}
            </div>
          </div>
          <span
            className={classNames(
              'transition margin-left-small flexbox flexbox-align-center shade-20 radius-normal padding-horizontal-small',
              { 'opacity-null': !hover }
            )}
            style={{ height: 24 }}
          >
            {ShortcutHelpers.toggleChannelsList.map((key, index) => (
              <span
                key={key}
                className={classNames('line-height-one bold font-size-normal', {
                  'margin-left-smaller': index,
                })}
              >
                {key}
              </span>
            ))}
          </span>
        </div>
      </div>
    </OnboardingStepPopover>
  )
}
